/*ěščřžýáíéúů*/

jQuery(function ($) {
	var defaultKraj = 'Jihomoravský kraj';

	function activateKraj(kraj) {
		// SVG mapa
		$('path.path-active').attr('class', '');
		$('path[data-reg="' + kraj + '"]').attr('class', 'path-active');

		// Karty zastoupení
		$('.kontakt-kraj.is-active').removeClass('is-active');
		$('.kontakt-kraj[data-reg="' + kraj + '"]').addClass('is-active');
	}

	activateKraj(defaultKraj);

	$('path').on('click', function () {
		var kraj = $(this).data('reg');
		activateKraj(kraj);
		var $oz = $('#oz2');
		if ($oz.length) {
			$('html, body').animate({ scrollTop: $oz.offset().top - 120 }, 400);
		}
	});

	$('.kontakt-mapa__hover').on('click', function () {
		$(this).addClass('is-hidden');
	});
});
